// src/pages/property-details/components/SimilarProperties.jsx
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SimilarProperties = ({ properties }) => {
  const formatPrice = (price, unit = '') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price) + (unit ? ` ${unit}` : '');
  };

  if (!properties || properties.length === 0) {
    return null;
  }

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-text-primary">Similar Agricultural Products</h2>
        <Link
          to="/property-listings"
          className="text-primary hover:text-primary-700 text-sm font-medium transition-colors duration-200"
        >
          View All Products
        </Link>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {properties.map((product) => (
          <Link
            key={product.id}
            to={`/property-details?id=${product.id}`}
            className="group block"
          >
            <div className="bg-surface rounded-lg overflow-hidden border border-border hover:shadow-elevation-2 transition-all duration-200">
              <div className="relative h-48">
                <Image
                  src={product.images?.[0]}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary text-white px-2 py-1 rounded-md text-xs font-medium">
                    {product.category}
                  </span>
                </div>
              </div>
              
              <div className="p-4">
                <h3 className="font-semibold text-text-primary mb-2 group-hover:text-primary transition-colors duration-200">
                  {product.title}
                </h3>
                
                <p className="text-primary font-bold text-lg mb-2">
                  {formatPrice(product.price, product.priceUnit)}
                </p>
                
                <div className="flex items-center space-x-2 text-text-secondary text-sm mb-3">
                  <Icon name="MapPin" size={14} />
                  <span className="truncate">{product.address}</span>
                </div>
                
                <div className="flex items-center justify-between text-sm">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <Icon name="Package" size={14} className="text-text-secondary" />
                      <span className="text-text-secondary">{product.quantity} {product.unit}</span>
                    </div>
                  </div>
                  
                  <button className="text-primary hover:text-primary-700 font-medium transition-colors duration-200">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SimilarProperties;